import { Button } from 'framework/ui/mui-builder';
import { useState } from 'react';
import { Modal } from 'framework/ui/ui-builder';
import { ModalForm } from 'framework/form';
import { useNewProjectUrl, useProjectTeamService } from 'domain/shared/newProject';
import { Box, Typography } from '@mui/material';

interface DeleteRiskModalProps {
  projectId: string;
  id: string;
  canDelete?: boolean;
}

const DeleteCriticalPeriodModal = ({ projectId, id, canDelete }: DeleteRiskModalProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { deleteCriticalPeriod } = useProjectTeamService();
  const { getProjectTeamUrl } = useNewProjectUrl();

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
      <Button variant="contained" color="error" onClick={() => setModalOpen(true)} disabled={!canDelete}>
        Delete critical period
      </Button>
      <Modal isOpen={modalOpen} onToggle={() => setModalOpen(false)} title="Delete critical period">
        <ModalForm
          closeModal={() => setModalOpen(false)}
          modalOpen={modalOpen}
          submitFormFunc={() => deleteCriticalPeriod(id)}
          afterSubmit={{
            redirect: getProjectTeamUrl(projectId),
            message: 'You are awesome! Critical period has been successfully deleted.',
          }}
        >
          <Typography pb={4}>Are you sure you want to delete this critical period?</Typography>
        </ModalForm>
      </Modal>
    </Box>
  );
};

export default DeleteCriticalPeriodModal;
